//export const APIURL = "http://localhost:8080/CuoriInMovimento/cim_server";
export const APIURL = "https://service-cm.maiosoft.net/cim_server";
